/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'personal-info-auth',
  template: require('./personal-info-auth.component.html'),
  styles: [require('./personal-info-auth.component.scss')]
})
export class PersonalInfoAuthComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
    this.personalInfo = this.appActions.getData('PersonalInformation', {});
    this.maritalStatusLocal = this.personalInfo.maritalStatus;
    this.failedDobSsnAttempt = 0;
    this.failedFourthAttempt = false;
    this.failedFifthAttempt = false;

     // Redux check to see if prepop failed
    const prepopFailed = this.appActions.getData('prepopFailed', false);
    if (prepopFailed) {
      this.router.navigate(['/personal-info'], { queryParamsHandling: 'preserve' });
    }

    // Check for existing customer to hide security question/answer
    if (this.flowManager.isTkCustomer === true) {
      this.form.inputs.securityQuestion.showUp = false;
      this.form.inputs.securityQuestion.require = false;
      this.form.inputs.securityAnswer.showUp = false;
      this.form.inputs.securityAnswer.require = false;
    }

    this.fieldstoValidate = [
      'dob',
      'ssn',
      'citizenship',
      'maritalStatus',
      'dependents',
    ];
  }

  ngOnInit() {
    const steps = this.flowManager.getStepArrays('personal-info-auth');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    if (this.flowManager.promoCode === false) {
      delete this.form.inputs.promoCode;
    } else {
      this.form.inputs.promoCode.noneditable = this.flowManager.promoCode;
      this.appActions.setData('PersonalInformation.promoCode', this.flowManager.promoCode);
    }
  }

  btnClick({ action, event }) {
    if (action !== 'back') {
      const personalInfo = this.appActions.getData('PersonalInformation', {});
      if (personalInfo && personalInfo.userEntered) {
          if (
            personalInfo &&
            personalInfo.dob &&
            personalInfo.ssn &&
            (personalInfo.userEntered.dob !== personalInfo.dob ||
              personalInfo.userEntered.ssn !== personalInfo.ssn)
          ) {
            this.failedDobSsnAttempt++;
      
            this.failedFourthAttempt = this.failedDobSsnAttempt <= 4 ? true : false;
            this.failedFifthAttempt = this.failedDobSsnAttempt >= 5 ? true : false;
          } else {
            // Set the userEntered ssn and dob to personal info for new user flow
            this.appActions.setData(
              'PersonalInformation.ssn',
              personalInfo.userEntered.ssn
            );
            this.appActions.setData(
              'PersonalInformation.dob',
              personalInfo.userEntered.dob
            );
            super.btnClick({ action, event });
          }
      }
    } else {
      super.btnClick({ action, event });
    }
  }
}